import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService } from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-text-collapse-config',
  templateUrl: './text-collapse-config.component.html',
  styleUrls: ['./text-collapse-config.component.scss']
})

export class AtwTextCollapseConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type_config: string;
  
  @Input() type: any; // xem đang ở page hay admin

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'cau_hinh_hieu_ung_tieu_de',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_tieu_de',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_noi_dung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'cau_hinh_hieu_ung_noi_dung',
      index: 5,
    },
  ];

  index = 0; // index của Collapse ddang được chọn
  listCollapse = []; // mảng Tiêu đề collpase
  listCollapseContent = []; // mảng Nội dung collapse 
  isOpenOptionsBorderHeader: boolean = false; // mở/đóng border của Tiêu đề
  isOpenOptionsBorderBody: boolean = false; // mở/đóng border của Nội dung

  dataAfterChange: any = {};
  effect_hover = [];
  effect_hover_data: any = {};
  iconPosition = [
    {
      name: "Bên phải",
      value: "row"
    },
    {
      name: "Bên trái",
      value: "row-reverse"
    }
  ];
  iconType = [
    {
      name: "Mũi tên",
      value: "down"
    },
    {
      name: "Dấu + và -",
      value: "plus"
    }
  ];




  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator
  ) { }


  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/text-collapse.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });

    for (let i = 0; i < this.staticdata.collapse.length; i++) {
      let obj = { value: i, name: "Tiêu đề Collapse " + (i + 1) };
      let objContent = { value: i, name: "Nội dung collapse " + (i + 1) }
      this.listCollapse.push(obj);
      this.listCollapseContent.push(objContent);
    }
  }


  ngOnChanges(changes: any): void {
    if (this.effect_hover) {
      if ([1, 5].includes(this.currentViewAll.index)) {
        const effectSub = this.currentViewAll.index == 1 ? '' : '_sub';
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[`${this.device}_animation${effectSub}_type`])
        if (this.config[`animation${effectSub}-selected`]?.id && this.config[`animation${effectSub}-selected`].id !== '000000') {
          this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config[`animation${effectSub}-selected`].id)?.[`customize${effectSub}`] ?? [];
        }
      }
    }
  }


  /**
   * Xử lý thay đổi số lượng Collapse
   */
  updateCollapse(value: any) {
    //cập nhật lại số lượng listCollapse để hiển thị đúng
    const currentCollapseLength = this.staticdata.collapse.length;
    const newLength = this.staticdata.total_collapse;

    this.listCollapse = Array.from(Array(value).keys()).map(i => ({
      value: i,
      name: `Tiêu đề Collapse ${i + 1}`
    }));

    this.listCollapseContent = Array.from(Array(value).keys()).map(i => ({
      value: i,
      name: `Nội dung collapse ${i + 1}`
    }));

    if (newLength < currentCollapseLength) {
      // xóa bớt
      this.index = 0;
      this.staticdata.collapse.splice((currentCollapseLength - newLength) * -1);
    }
    else {
      // thêm/update
      this.staticdata.collapse.push(
        { 
          ['header_' + this.functionService.selectedLanguageCode]: this.listCollapse[this.listCollapse.length - 1].name, 
          ['content_' + this.functionService.selectedLanguageCode]: this.listCollapseContent[this.listCollapseContent.length - 1].name 
        }
      );
    }

    this.handleChangeStaticdata();
  }


  /**
   * Hàm chọn tiêu đề
   */
  chooseHeader(value: any) {
    this.index = value;
  }




  /**
   * Hàm cập nhật dữ liệu staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }


  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }


  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }


  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }
  

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false
  };


  customize = [];
  /**
 * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
 * @param event customize sau khi thay đổi
 */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetailChild(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[4]);
  }

  /**
   * Xử lý thay đổi cấu hình staticdata, check xem có thay đổi trên common data không
   */
  handleChangeStaticdata() {
    this.updateStaticData();
  }


}